import type { Transaction, TransactionGroup } from "../shared/types";
import { readTransactionGroup, transactionGroups } from "./transaction-groups";

export const transactionPaymentReturnContextKey = "carepass.transaction.payment-return-context.v1";

/** Tab-only navigation context, saved immediately before leaving for the payment window. */
export function rememberTransactionPaymentReturn(transaction: Pick<Transaction, "id" | "memberId">, group = readTransactionGroup()): void {
  try { window.sessionStorage.setItem(transactionPaymentReturnContextKey, JSON.stringify({ transactionId: transaction.id, memberId: transaction.memberId, group })); } catch { /* Storage denial must not block an otherwise valid checkout. */ }
}

export function clearTransactionPaymentReturn(): void {
  try { window.sessionStorage.removeItem(transactionPaymentReturnContextKey); } catch { /* No persisted context is required for direct entry. */ }
}

/** Call only after the authenticated member API has returned the owned transaction. */
export function consumeTransactionPaymentReturn(transaction: Pick<Transaction, "id" | "memberId">): TransactionGroup {
  let stored: string | null = null;
  try { stored = window.sessionStorage.getItem(transactionPaymentReturnContextKey); } catch { return "ALL"; }
  clearTransactionPaymentReturn();
  if (!stored) return "ALL";
  try {
    const value: unknown = JSON.parse(stored);
    if (!value || typeof value !== "object") return "ALL";
    const context = value as Record<string, unknown>;
    if (context.transactionId !== transaction.id || context.memberId !== transaction.memberId) return "ALL";
    return transactionGroups.find(group => group.value === context.group)?.value ?? "ALL";
  } catch { return "ALL"; }
}
